<div class="profile-form">
    <div class="container">
 
        <div class="thanks-info">
         {{'Report has been submitted' | translate}}
        </div>
  
    </div>
  </div>
  